import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { activateTGPDataType } from '@/Pages/Frontend/Components/TGPlus/CreateSubscription/CreateSubscription'
import { createSolarProviderType } from '@/Pages/Frontend/Components/TGPlus/CreateSubscription/CreateSolarProvider'
import { ExperienceForm } from '@/Pages/Frontend/Components/TGPlus/ExperienceCenter/CreateNewExperienceCenter'

AxiosInterceptor()

const tradegridPlusService = {
  async index(
    pageNumber: number,
    sortOrder: string,
    status: string,
    isOverdue?: boolean | undefined,
  ) {
    const overdueParam = isOverdue === undefined ? '' : `&isOverdue=${isOverdue}`
    return axios.get(
      `/tradegridplus?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}${overdueParam}`,
    )
  },

  async exportSubscription(sortOrder: string, status: string | undefined) {
    if (status) {
      return await axios.get(`/tradegridplus/export/csv?sortOrder=${sortOrder}&status=${status}`)
    } else {
      return axios.get(`/financialtransactions/export/csv?sortOrder=${sortOrder}`)
    }
  },

  async searchReferrals(
    endpoint: string,
    pageNumber: number,
    sortOrder: string,
    status: string | undefined,
  ) {
    const statusParam = status === undefined ? '' : `&status=${encodeURIComponent(status)}`
    const queryParams = `${endpoint}&pageNumber=${pageNumber ?? 1}&sortOrder=${encodeURIComponent(sortOrder)}${statusParam}`
    return await axios.get(`/customer-referral?${queryParams}`)
  },

  makePayment: async (id: string | undefined) => {
    return await axios.post(`/tradegridplus/${id}/makePaymentForTradegridPlus`)
  },

  decommission: async (id: string | undefined) => {
    return await axios.put(`/tradegridplus/${id}/decomission`)
  },

  updateDueDate: async (
    id: string | undefined,
    data: { nextSubscriptionPaymentDueDate: string },
  ) => {
    return await axios.put(`/tradegridplus/${id}/dueDate`, data)
  },

  search: async (endpoint: string, pageNumber: number, sortOrder: string, status: string) => {
    const queryParams = `${endpoint}&pageNumber=${pageNumber ?? 1}&sortOrder=${sortOrder}&status=${status}`
    return await axios.get(`/tradegridplus?${queryParams}`)
  },

  subscriptionTransaction: async (id: string | undefined, pageNumber: number, owner: string) => {
    return await axios.get(`/tradegridplus/${id}?pageNumber=${pageNumber}&owner=${owner}`)
  },

  async solarProviders(pageNumber: number, sortOrder: string, status: string) {
    return await axios.get(
      `/tradegridplus/solarProvider/account?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}`,
    )
  },

  createSolarProvider: async (data: createSolarProviderType) => {
    return await axios.post('/tradegridplus/solarProvider/account', data)
  },

  async solarProviderStations(
    pageNumber: number,
    sortOrder: string,
    status: string,
    customerMsisdn: string | undefined,
  ) {
    return axios.get(
      `/tradegridplus?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}&solarProviderAccountId=${customerMsisdn}`,
    )
  },
  //

  async users(pageNumber: number, sortOrder: string) {
    return axios.get(`/tradegridplus/users/all?pageNumber=${pageNumber}&sortOrder=${sortOrder}`)
  },

  async stations(
    pageNumber: number,
    sortOrder: string,
    status: string,
    customerMsisdn: string | undefined,
  ) {
    return axios.get(
      `/tradegridplus?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}&customerMsisdn=${encodeURIComponent(customerMsisdn ?? '')}`,
    )
  },

  async userReferal(pageNumber: number, userUuid: string | undefined) {
    return axios.get(`/tradegridplus/users?pageNumber=${pageNumber}&referredByUserId=${userUuid}`)
  },

  async exportCustomerReferals(sortOrder: string, status: string | undefined) {
    if (status) {
      return await axios.get(
        `/customer-referral/export/csv?sortOrder=${sortOrder}&status=${status}`,
      )
    } else {
      return axios.get(`/customer-referral/export/csv?sortOrder=${sortOrder}`)
    }
  },

  async single(pageNumber: number, id: string | undefined) {
    return axios.get(`/tradegridplus?pageNumber=${pageNumber}&id=${id}`)
  },

  async singleSub(id: string | undefined) {
    return axios.get(`/tradegridplus/single/${id}`)
  },

  async approveSubscription(status: string, id: string | undefined) {
    return axios.put(`/tradegridplus/${id}/approval/${status}`)
  },

  async updateSubscription(
    data: { solarPowerCapacity: string; monthlySubscriptionMajor: number },
    id: string | undefined,
  ) {
    return axios.put(`/tradegridplus/${id}/updateInstallationDetails`, data)
  },

  async subscriptionInstallationCompleted(
    data: {
      plan: string
      solarProviderAccountId: string
      nextSubscriptionPaymentDueDate?: Date | undefined
      installationCompletedAt?: Date | undefined
      bypassFirstPayment?: boolean
      decommissionedStationId?: string
      enableMultiStationBonus?: boolean
    },
    id: string | undefined,
  ) {
    return axios.put(`/tradegridplus/${id}/installationComplete`, data)
  },

  activateTGPlus: async (data: activateTGPDataType) => {
    return await axios.post('/tradegridplus', data)
  },

  widthdrawWallet: async (data: {
    amountMajor: number
    solarProviderAccountId: string | undefined
  }) => {
    return await axios.post('/tradegridplus/solarProvider/account/withdraw', data)
  },

  createReferal: async (data: {
    referralName: string
    businessName: string
    phoneNumber: string
    customerMsisdn: string
  }) => {
    return await axios.post('/customer-referral', data)
  },

  async createExperienceCenter(data: ExperienceForm) {
    return await axios.put('/experience-centre', data)
  },
}
export default tradegridPlusService
